import { notification } from 'antd';

/**
 * Component that shows notifications for session-related events
 */
export const SessionExpiredNotification = () => {
    // This component is included in the app to enable session notifications
    // The actual notification logic is handled by the AuthorizeService
    return null; // This component doesn't render anything visible
};

/**
 * Utility function to show session expiration notification
 */
export const showSessionExpiredNotification = () => {
    notification.warning({
        message: 'Session Expired',
        description:
            'Your session has expired due to activity on another device. Please log in again.',
        duration: 5,
        placement: 'topRight',
    });
};

export default SessionExpiredNotification;
